import { render } from "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=template&id=7d264e25&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMaterialPolitical.vue?vue&type=style&index=0&id=7d264e25&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d264e25"]])

export default __exports__